import {
  DeleteOutlined,
  InboxOutlined,
  PaperClipOutlined,
} from "@ant-design/icons";
import { Button, Space, Tag, Typography, Upload } from "antd";

const { Text } = Typography;

const PREVIOUS_APPLICATION_ATTACHMENT = "Your Previously Submitted Application.pdf";

// What goes along with the renewal email: the previous application, attached automatically
// unless removed, and an optional certificate the sender uploads (kept local until Send).
const RenewalEmailAttachments = ({
  includePreviousApplication,
  onIncludePreviousApplicationChange,
  fileList,
  onFileListChange,
}) => {
  const uploadProps = {
    name: "file",
    multiple: false,
    action: undefined,
    fileList,
    accept: ".pdf",
    beforeUpload(file) {
      onFileListChange([file]);
      return false;
    },
    onRemove() {
      onFileListChange([]);
    },
  };

  return (
    <div style={{ marginTop: 16 }}>
      <Text strong>Attachments</Text>
      <div style={{ margin: "4px 0 8px" }}>
        {includePreviousApplication ? (
          <Space size={4}>
            <PaperClipOutlined />
            <Text>{PREVIOUS_APPLICATION_ATTACHMENT}</Text>
            <Tag>added automatically</Tag>
            <Button
              type="text"
              size="small"
              icon={<DeleteOutlined />}
              title="Remove file"
              aria-label="Remove the previous application"
              onClick={() => onIncludePreviousApplicationChange(false)}
            />
          </Space>
        ) : (
          <Space size={4}>
            <Text type="secondary">
              The previous application will not be attached.
            </Text>
            <Button
              type="link"
              size="small"
              onClick={() => onIncludePreviousApplicationChange(true)}
            >
              Attach it again
            </Button>
          </Space>
        )}
      </div>
      <Upload.Dragger {...uploadProps}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Click or drag the <strong>Certificate of Insurance (PDF)</strong>{" "}
          here to attach it
        </p>
        <p className="ant-upload-hint">
          Optional. You can confirm sending without one.
        </p>
      </Upload.Dragger>
    </div>
  );
};

export default RenewalEmailAttachments;
